import { CClassTribIbsCbsStruct } from './c-class-trib-ibs-cbs.struct';
import { CstCofinsStruct } from './cst-cofins.struct';
import { CstIbsCbsCclasstribIbsCbsStruct } from './cst-ibs-cbs-cclasstrib-ibs-cbs.struct';
import { CstIcmsStruct } from './cst-icms.struct';
import { CstIpiStruct } from './cst-ipi.struct';
import { CstIssqnStruct } from './cst-issqn.struct';
import { CsosnStruct } from './csosn.struct';
import { CstPisStruct } from './cst-pis.struct';
import { LookupItemStruct } from './lookup-item.struct';
import { ModalidadeBcOption } from './modalidade-bc-option.struct';

/**
 * Os catálogos fiscais que um item de documento comercial consome (abas do modal do item).
 *
 * Carregados uma vez pela casca do diálogo da venda e da NF-e de saída
 * (`MotorFiscalLookupService.getVendaItemLookup`) e
 * passados por `@Input`: são os mesmos para todas as abas, e cada aba buscando o seu daria sete
 * cargas para mostrar um item.
 */
export interface LookupsFiscais {
    cstsIcms: CstIcmsStruct[];
    /** CSOSN do Simples Nacional (CRT 1 e 4): a aba Simples substitui a ICMS pelo regime. */
    csosns: CsosnStruct[];
    cstsIpi: CstIpiStruct[];
    cstsPis: CstPisStruct[];
    cstsCofins: CstCofinsStruct[];

    origensMercadoria: LookupItemStruct[];
    tiposItemSped: LookupItemStruct[];
    modalidadesBc: ModalidadeBcOption[];
    modalidadesBcSt: ModalidadeBcOption[];
    motivosDesoneracao: LookupItemStruct[];
    /** Motivos da redução da alíquota ad rem do ICMS monofásico (motRedAdRem, CST 15). */
    motivosReducaoAdRem: LookupItemStruct[];

    /** Naturezas de SAIDA: o item pode sobrepor a do documento, e documento comercial nao entra. */
    naturezas: LookupItemStruct[];

    cstsIbsCbs: CClassTribIbsCbsStruct[];
    classificacoesIbsCbs: CClassTribIbsCbsStruct[];
    relacoesIbsCbs: CstIbsCbsCclasstribIbsCbsStruct[];

    /** Indicadores de exigibilidade (indISS) e de incentivo fiscal do ISSQN: a aba ISSQN do item de serviço. */
    indicadoresIss: CstIssqnStruct[];
    indicadoresIncentivoFiscalIssqn: LookupItemStruct[];
}

export const LOOKUPS_FISCAIS_VAZIOS: LookupsFiscais = {
    cstsIcms: [], csosns: [], cstsIpi: [], cstsPis: [], cstsCofins: [],
    origensMercadoria: [], tiposItemSped: [], modalidadesBc: [], modalidadesBcSt: [],
    motivosDesoneracao: [], motivosReducaoAdRem: [], naturezas: [],
    cstsIbsCbs: [], classificacoesIbsCbs: [], relacoesIbsCbs: [],
    indicadoresIss: [], indicadoresIncentivoFiscalIssqn: [],
};
